import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-view" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "nested" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, {
      title: _ctx.$route.name,
      iconType: "menu",
      onOnClickLeftIcon: _ctx.onClickLeftIcon
    }, null, 8, ["title", "onOnClickLeftIcon"]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/manager-list"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("新增/編輯/刪除管理者")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/search-log"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("管理者操作記錄查詢")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
            }, "服務機制系統設定"),
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/service-list"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("服務項目管理")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/staff-list"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("服務人員管理")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isMenuExpaned = false)),
                  to: "/report-list"
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("服務機制回報查詢")
                  ])),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/announcement-permission"
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("公播機制系統權限設定")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/announcement-list"
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("公播機制系統設定")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/search-class"
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createTextVNode("課程資訊導引服務系統")
              ])),
              _: 1
            })
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("li", null, [
            _createElementVNode("a", {
              target: "_blank",
              href: "https://gate-cpbae.nccu.edu.tw/"
            }, "門禁系統")
          ], -1)),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/call-log-list"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode("查詢呼叫紀錄")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _ctx.logout,
              to: "/login"
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode("登出")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 512), [
          [_vShow, _ctx.isMenuExpaned]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ]))
}